import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { appConstants as c } from './app/constants';
import { LedgerTableComponent, ToolbarComponent } from './components';
// useHttp must be after wsConnect import to prevent ` Cannot access 'getUri' before initialization`
import { HttpMethod, useHttp } from './hooks';
import { FetchLedgerEntriesPayload, LedgerRecordData } from './types';
import { log } from './utils';
import { wsConnect } from './utils/ws';

// ignore websocket.js:88 WebSocket connection to 'wss://10.8.100.32/websockets/?EIO=4&transport=websocket' failed: Error in connection establishment: net::ERR_CONNECTION_REFUSED
// process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

export const App = () => {
  useEffect(() => {
    wsConnect();
  }, []);
  const { sendRequest } = useHttp();
  // TODO: cleanUp
  // const [fetchLedgerState, setFetchLedgerState] = useState<FetchLedgerEntriesPayload>()
  const [ledgerData, setLedgerData] = useState<LedgerRecordData>()
  const transformFunction = (data: { message: string }) => {
    // console.log(data);
  }
  const transformFunctionLedgerData = (data: LedgerRecordData) => {
    // log(`transformFunctionLedgerData data.pagination ${JSON.stringify(data.pagination, undefined, 2)}`)
    setLedgerData(data);
  }
  const errorFunction = (error: any) => {
    console.error(error);
  }

  const pingClickHandler = async () => {
    await sendRequest({
      url: `${c.VALUES.apiUrl}/ping`,
      debug: false
    }, transformFunction, errorFunction);
  }

  const wsEchoClickHandler = async () => {
    await sendRequest({
      url: `${c.VALUES.apiUrl}/api/ws-echo`,
      method: HttpMethod.POST,
      headers: c.VALUES.apiHeaders,
      body: { message: 'hi there' },
      debug: false
    }, transformFunction, errorFunction);
  }

  const filterLedgerEntriesHandler = async (payload?: FetchLedgerEntriesPayload) => {
    // log(`filterLedgerEntriesHandler payload: ${JSON.stringify(payload, undefined, 2)}`)
    fetchLedgerEntries(payload);
  }

  const fetchLedgerEntries = useCallback(async (payload?: FetchLedgerEntriesPayload) => {
    // log(`fetchLedgerEntries payload ${JSON.stringify(payload, undefined, 2)}`)
    sendRequest({
      url: `${c.VALUES.apiUrl}/api/ledger-entries/get`,
      // need to use post, axios don't work 
      method: HttpMethod.POST,
      // get in axios must use data, not body
      headers: c.VALUES.apiHeaders,
      body: payload,
      debug: false
    }, transformFunctionLedgerData, errorFunction);
  }, [sendRequest]);

  useEffect(() => {
    // initial entries with initial fetchLedgerState
    fetchLedgerEntries(c.VALUES.ledger.defaultPayload);
    return () => { }
  }, [fetchLedgerEntries])

  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" style={{color: '#21371b'}} gutterBottom>
          Critical-Links : CLK-Ledger
        </Typography>
        {/* <pre>
          {JSON.stringify(process.env, undefined, 2)}
        <Box sx={{ marginBottom: 1 }}>
          <Button variant="contained" sx={{ marginRight: 1 }} onClick={pingClickHandler}>/ping</Button>
          <Button variant="contained" sx={{ marginRight: 1 }} onClick={wsEchoClickHandler}>/wsEcho</Button>
        </Box>
        </pre> */}
        <ToolbarComponent filterLedgerEntriesHandler={filterLedgerEntriesHandler} pagination={ledgerData?.pagination} />
        <LedgerTableComponent data={ledgerData} />
      </Box>
    </Container>
  );
};
